import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'

import User from '@/router/user'
import Company from '@/router/company'
import Park from '@/router/park'
import Meeting from '@/router/meeting'
import Electronic from '@/router/electronic'
import CompanyServe from '@/router/serve'
import Basic from '@/router/basic'
import Authority from '@/router/authority'

NProgress.configure({ showSpinner: false })
const Login = () => import("@/pages/login");
const Index = () => import("@/pages/index");

Vue.use(Router)

const children = [
  ...User,
  ...Company,
  ...Park,
  ...Meeting,
  ...Electronic,
  ...CompanyServe,
  ...Basic,
  ...Authority,
]

const router = new Router({
  routes: [
    {
      path: '',
      redirect: '/index',
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/index',
      component: Index,
      children
    }
  ]
})


router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  NProgress.done()
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js